const state = {
  show: false,
};

const mutations = {
  setShow(state, isShow) {
    state.show = isShow;
  },
};

const actions = {};

const getters = {
  show(state) {
    return state.show;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
